import { render } from "./AssetSummary.vue?vue&type=template&id=a3851f2c&ts=true"
import script from "./AssetSummary.vue?vue&type=script&lang=ts"
export * from "./AssetSummary.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\iflam\\OneDrive\\নথিসমূহ\\tms-next\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__